import { Typography } from '@scale/scaleui';
import { MultiTurnInteractionConfiguration } from '@scale/shared/types/chat';
import { AudioConfigurator } from 'react-scale/components/scalers/tasks/ThreadedInteraction/ChatConfigurationEditor/components/AudioConfigurator';
import ImageReferenceBuilder from 'react-scale/components/scalers/tasks/ThreadedInteraction/ChatConfigurationEditor/components/ImageReferenceBuilder';

interface MultimodalOptionsProps {
  value: MultiTurnInteractionConfiguration;
  onSubmit: (config: MultiTurnInteractionConfiguration) => void;
  useAccordion?: boolean;
}

const MultimodalOptions = ({ value, onSubmit, useAccordion = true }: MultimodalOptionsProps) => {
  return (
    <div className="flex flex-col gap-2">
      <Typography.H3>Multimodal Options</Typography.H3>
      <Typography.Paragraph2 color="text-neutral-500">
        Configure options for image and audio attachments.
        <br />
        This does not affect text collection steps.
      </Typography.Paragraph2>

      <div className="flex flex-col gap-4">
        <ImageReferenceBuilder
          name="Image Configs"
          existingValue={value}
          updateProperty={(updatedValue: MultiTurnInteractionConfiguration) =>
            onSubmit({
              ...value,
              ...updatedValue,
            })
          }
          useAccordion={useAccordion}
        />

        <AudioConfigurator
          existingValue={value}
          name="Audio Configs"
          updateProperty={onSubmit}
          variant={useAccordion ? 'accordion' : 'config_section_header'}
        />
      </div>
    </div>
  );
};

export default MultimodalOptions;
